import React, { useEffect } from "react";

// Libraries
import { motion } from "framer-motion";

// SCSS
import "./GameOver.scss";

// Images
import YellowLeftStarIcon from "../../static/img/yellow-left-star-icon.png";
import YellowCenterStarIcon from "../../static/img/yellow-center-star-icon.png";
import YellowRightStarIcon from "../../static/img/yellow-right-star-icon.png";
import LeftStarIcon from "../../static/img/left-star-icon.png";
import CenterStarIcon from "../../static/img/center-star-icon.png";
import RightStarIcon from "../../static/img/right-star-icon.png";
import { GC } from "../../utilities/GamecentreSevice";
import { storage } from "../../utilities/storage";
import { backgroundMusicStop } from "../../utilities/sounds";

export default function GameOver(props) {
  const metadata = props.location.state;
  const gameLevelData = storage.get.levelData();
  const gameDetails = storage.get.gameDetails();
  const checkSaveData = gameLevelData?.levelData?.length ? true : false;
  const totalLevelCleared = gameLevelData?.totalLevelCleared || 0;
  const totalAccuracy = gameLevelData?.totalAccuracy || 0;

  const goToNextGame = () => {
    GC.sendGameEndMessage()
    storage.destroy.all();
  };

  useEffect(() => {
    backgroundMusicStop()
    // const { authToken, gameplayId, type } = GgcLifeCycleManager.getSession();
    // // game id is qunique id for each game = will be provided by sagar
    // // linkId is gameplayId form getSession method

    // console.log("========GET SESSION RESULT========");
    // console.log(authToken);
    // console.log(gameplayId);
    // console.log(type);
    // console.log("==================================");

    // API.post(
    //   `/8816f617-d7ba-411c-9c72-86d959197031/link/${gameplayId}`,
    //   {
    //     ...metadata.result.backendObj,
    //   },
    //   {
    //     headers: {
    //       Authorization: authToken,
    //     },
    //   }
    // )
    //   .then((result) => {
    //     console.log("SUCCESSFULLY UPDATED THE DATA IN THE BACKEND!");
    //   })
    //   .catch((err) => {
    //     console.log("ERROR WHILE FEEDING DATA TO BACKEND!");
    //   });
  }, []);

  const getStars = (starsToShow = 3) => {
    return (
      <div className="view-game-over__star-icons-container">
        <img
          src={starsToShow >= 1 ? YellowLeftStarIcon : LeftStarIcon}
          alt=""
          className="view-game-over__star-icons-container--left-star"
        />
        <img
          src={starsToShow >= 2 ? YellowCenterStarIcon : CenterStarIcon}
          alt=""
          className="view-game-over__star-icons-container--center-star"
        />
        <img
          src={starsToShow >= 3 ? YellowRightStarIcon : RightStarIcon}
          alt=""
          className="view-game-over__star-icons-container--right-star"
        />
      </div>
    );
  };

  return (
    <div className="view-game-over">
      <motion.div
        initial={{ top: "40%", x: "-50%", scale: 0, opacity: 0 }}
        animate={{
          top: ["40%", "40%", "40%", "40%", "5%"],
          x: ["-50%", "-50%"],
          scale: [0, 1, 1.5, 1.5, 1],
          opacity: [0, 1, 1],
        }}
        transition={{
          duration: 3,
          delay: 0,
        }}
        className="view-game-over__logo-container"
      >
        <img
          className="view-game-over__logo-container--logo"
          src={gameDetails?.mediaUrl || require("../../static/img/home-page-logo.png")}
          alt=""
        />
      </motion.div>

      <motion.div
        className="view-game-over__main-container"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{
          duration: 1,
          delay: 3,
        }}
      >
        <div className="view-game-over__container">
          {/*{getStars(2)}*/}

          <div className="view-game-over__title">You did great!</div>

          <div className="view-game-over__stats-container">
            {/* Levels Completed */}
            <div className="view-game-over__stats-container--stat">
              <p className="stat__title">Levels completed</p>
              <p className="stat__value">
                {metadata?.result?.totalLevelCompleted || (checkSaveData && totalLevelCleared) || 0}
              </p>
            </div>

            {/* Accuracy */}
            <div className="view-game-over__stats-container--stat">
              <p className="stat__title">Accuracy</p>
              <p className="stat__value">{metadata?.result?.accuracy || (checkSaveData && totalAccuracy) || 0}%</p>
            </div>
          </div>

          <div className="view-game-over__sub-title">
            {metadata && metadata?.reason === "timeup"
              ? "You ran out of time!" : null}
          </div>

          <button
            className="view-game-over__primary-button"
            onClick={goToNextGame}
          >
            Continue
          </button>

          {/* <button className="view-game-over__secondary-button">
  PLAY AGAIN {"->"}
</button> */}
        </div>
      </motion.div>
    </div>
  );
}
